import React from "react";
import bigo from "./bingo-reno.png";
import './bingoRenoHeader.css'

export function BingoRenoHeader() {





    return (<div className="Header-bingo">
        <div className="Header-presentation">
            <img className="Header-logo" src={bigo}/>
        </div>
    </div>);


}